import React from 'react';
import { 
    TextDecoration
    } from '../SetsAndItems.styled';
import{
    isMobileDevice, 
    setCurrencyFormat
} from 'src/utils/util'; 
import { useTranslation } from 'react-i18next';
import { Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';   
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import { BLACK_FONT_COLOR, DARK_GRAY_FONT_COLOR, DARK_NAVY_FONT_COLOR,
     FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX, 
     X_SMALL_TEXT_PX, PINK_HIGHLIGHT_COLOR} from 'src/styles/fonts/MCFontConstants'; 
     
const PriceDetailsRow = (props) => {
    const { priceMarginTop, 
            basePrice,
            isBundle,
            setOrItemChildren,
            quickOrderFlag,
            discount,
            adjustedUnitPrice,
            extPrice,
            adjustedExtPrice
             } = props;
    
    const classes = useStyles();
    const { t } = useTranslation();
    
    return (
          <Box
            style={{
                width: '100%',
                marginTop: isMobileDevice()
                    ? priceMarginTop
                        ? priceMarginTop
                        : '0px'
                    : '',
            }}
        >
            {basePrice ? (
                <Grid
                    container
                    justifyContent={'space-between'}
                >
                    <Grid
                        className={classes.summaryContent}
                        item
                        sm={4}
                        xs={4}
                    >
                        {isBundle? 
                        <CustomLabel
                            styles={{
                                textAlign: 'left',
                                color: BLACK_FONT_COLOR,
                                fontSize: X_SMALL_TEXT_PX,
                                fontFamily: FONT_FAMILY_DEMI,
                                letterSpacing: '0px',
                                lineHeight: '20px',
                            }}
                            label={`In Bundle (${
                                setOrItemChildren && setOrItemChildren?.length
                                    ? setOrItemChildren?.length
                                    : 0
                            })`}
                        />
                        :null}
                    </Grid>
                    <Grid
                        className={classes.summaryContent}
                        item
                        sm={4}
                        xs={4}
                    >
                        <CustomLabel
                            styles={{
                                textAlign: 'right',
                                color: DARK_GRAY_FONT_COLOR,
                                fontSize: SEMANTIC_TEXT_SMALL_PX,
                                fontFamily: FONT_FAMILY_DEMI,
                                letterSpacing: '0px',
                                lineHeight: '20px',
                                // marginLeft: isMobileDevice()
                                //     ? ''
                                //     : '10px',
                                marginLeft: isMobileDevice()
                                    ? ''
                                    : '10px',
                            }}
                            label={t(
                                'equity.common.feesAndItems.unitPrice'
                            )}
                        />
                    </Grid>
                    <Grid
                        className={classes.summaryContent}
                        item
                        sm={4}
                        xs={4}
                    >
                        <CustomLabel
                            styles={{
                                textAlign: 'right',
                                color: DARK_GRAY_FONT_COLOR,
                                fontSize: SEMANTIC_TEXT_SMALL_PX,
                                fontFamily: FONT_FAMILY_DEMI,
                                letterSpacing: '0px',
                                lineHeight: '20px',
                            }}
                            label={t(
                                'equity.common.feesAndItems.extPrice'
                            )}
                        />
                    </Grid>
                </Grid>
            ) : null}
            {(isBundle && !quickOrderFlag && discount) || (!isBundle && discount) ? (
                <Grid
                    container
                    justifyContent={'space-between'}
                >
                    <Grid
                        className={classes.summaryContent}
                        item
                        sm={4}
                        xs={4}
                    >
                        <CustomLabel
                            styles={{
                                textAlign: 'left',
                                color: PINK_HIGHLIGHT_COLOR,
                                fontSize: X_SMALL_TEXT_PX,
                                fontFamily: FONT_FAMILY_DEMI,
                                letterSpacing: '0px',
                                lineHeight: '20px',
                            }}
                            label={
                                discount
                                    ? discount +
                                    t(
                                        'equity.common.feesAndItems.discount'
                                    )
                                    : ''
                            }
                        />
                    </Grid>
                    <Grid
                        className={classes.summaryContent}
                        item
                        sm={4}
                        xs={4}
                    >
                        <TextDecoration
                            textdecoration={'line-through'}
                        >
                            <CustomLabel
                                styles={{
                                    textAlign: 'right',
                                    color: PINK_HIGHLIGHT_COLOR,
                                    fontSize: SMALL_TEXT_PX,
                                    fontFamily: FONT_FAMILY_DEMI,
                                    letterSpacing: '0px',
                                    lineHeight: '20px',
                                    marginTop:
                                        isMobileDevice()
                                            ? '2px'
                                            : '', 
                                }}
                                label={
                                    basePrice
                                        ? setCurrencyFormat(
                                            basePrice
                                        )
                                        : adjustedUnitPrice
                                }
                            />
                        </TextDecoration>
                    </Grid>
                    <Grid
                        className={classes.summaryContent}
                        item
                        sm={4}
                        xs={4}
                    >
                        <TextDecoration
                            textdecoration={'line-through'}
                        >
                            <CustomLabel
                                styles={{
                                    textAlign: 'right',
                                    color: PINK_HIGHLIGHT_COLOR,
                                    fontSize: SMALL_TEXT_PX,
                                    fontFamily: FONT_FAMILY_DEMI,
                                    letterSpacing: '0px',
                                    lineHeight: '20px',
                                    marginTop:
                                        isMobileDevice()
                                            ? '2px'
                                            : '', 
                                }}
                                label={
                                    extPrice
                                        ? extPrice
                                        : adjustedExtPrice
                                }
                            />
                        </TextDecoration>
                    </Grid>
                </Grid>
            ) : null}
            {basePrice ? (
                <Grid
                    container
                    justifyContent={'space-between'}
                >
                    <Grid
                        className={classes.summaryContent}
                        item
                        sm={4}
                        xs={4}
                    ></Grid>
                    <Grid
                        className={classes.summaryContent}
                        item
                        sm={4}
                        xs={4}
                    >
                        <CustomLabel
                            styles={{
                                textAlign: 'right',
                                color: DARK_NAVY_FONT_COLOR,
                                fontSize: SMALL_TEXT_PX,
                                fontFamily: FONT_FAMILY_REGULAR,
                                letterSpacing: '0px',
                                lineHeight: '20px',
                            }}
                            label={
                                adjustedUnitPrice
                                    ? adjustedUnitPrice
                                    : setCurrencyFormat(
                                        basePrice
                                    )
                            }
                        />
                    </Grid>
                    <Grid
                        className={classes.summaryContent}
                        item
                        sm={4}
                        xs={4}
                    >
                        <CustomLabel
                            styles={{
                                textAlign: 'right',
                                color: DARK_NAVY_FONT_COLOR,
                                fontSize: SMALL_TEXT_PX,
                                fontFamily: FONT_FAMILY_REGULAR,
                                letterSpacing: '0px',
                                lineHeight: '20px',
                            }}
                            label={
                                adjustedExtPrice
                                    ? adjustedExtPrice
                                    : extPrice
                            }
                        />
                    </Grid>
                </Grid>
            ) : null}
        </Box>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    contentPadding: {
        paddingBottom: '10px',
    },
    summaryContent: {
        textAlign: 'center',
        color: BLACK_FONT_COLOR,
        fontSize: X_SMALL_TEXT_PX,
        fontFamily: FONT_FAMILY_REGULAR,
        letterSpacing: '0px',
        lineHeight: '24px',
    },
    paper: {
        padding: theme.spacing(2),
    },
}));

export default PriceDetailsRow;